import React, { useEffect, useState, useRef } from "react";
import { Box, Typography } from "@mui/material";
import {
  Header,
  SidebarComponentPlayback,
  CameraGridPlayback,
} from "./Sidebar";
import axios from "axios";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import { v4 as uuidv4 } from "uuid";

const COLORS = {
  DARK_GRAY: "#2A2E34",
};

const Rewatch = () => {
  // const [mobileOpen, setMobileOpen] = useState(false);
  // const [currentTime, setCurrentTime] = useState("");
  // const [gridItems, setGridItems] = useState([]);
  // const [allCameras, setAllCameras] = useState([]);
  // const [selectedLocs, setSelectedLocs] = useState([]);
  // const [getdc, setGetdc] = useState([]);
  // const [selectedCity, setSelectedCity] = useState("");
  // const [locdetails, setLocdetails] = useState([]);
  // const [playbackdata, setPlaybackdata] = useState();
  // const [datedetails, setDatedetails] = useState([]);
  // const [selecteddate, setSelecteddate] = useState("");
  // const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  // const [selectedcamera, setSelectedcamera] = useState("");

  // const pollingRef = useRef(null);
  // const connectionIdRef = useRef(uuidv4());

  // useEffect(() => {
  //   const updateTime = () => {
  //     const now = new Date();
  //     const day = String(now.getDate()).padStart(2, "0");
  //     const month = String(now.getMonth() + 1).padStart(2, "0");
  //     const year = now.getFullYear();
  //     const hours = String(now.getHours()).padStart(2, "0");
  //     const minutes = String(now.getMinutes()).padStart(2, "0");
  //     const seconds = String(now.getSeconds()).padStart(2, "0");
  //     const dayName = now.toLocaleString("en-US", { weekday: "short" });
  //     setCurrentTime(
  //       `${day}/${month}/${year} ${hours}:${minutes}:${seconds} ${dayName}`
  //     );
  //   };

  //   updateTime();
  //   const interval = setInterval(updateTime, 1000);
  //   return () => clearInterval(interval);
  // }, []);

  // const handleGetDc = async () => {
  //   try {
  //     const response = await axios.post(
  //       "https://api.more.in/v1/vigil_portal",
  //       { rawPath: "/get_dc" },
  //       {
  //         headers: {
  //           Authorization: Cookies.get("ssp_sso_token"),
  //           "content-type": "application/json",
  //         },
  //       }
  //     );
  //     if (response?.data?.status === "success") {
  //       setGetdc(response?.data?.message?.records);
  //     } else {
  //       toast.error(
  //         response?.data?.message || "Something went wrong, Please try again later!",
  //         { position: "top-right" }
  //       );
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  // const handleGetLogs = async () => {
  //   try {
  //     const response = await axios.post(
  //       "https://api.more.in/v1/vigil_portal",
  //       { dc_city: selectedCity, rawPath: "/get_locs" },
  //       {
  //         headers: {
  //           Authorization: Cookies.get("ssp_sso_token"),
  //           "content-type": "application/json",
  //         },
  //       }
  //     );
  //     if (response?.data?.status === "success") {
  //       setAllCameras(response?.data?.message?.records);
  //     } else {
  //       toast.error(
  //         response?.data?.message || "Something went wrong, Please try again later!",
  //         { position: "top-right" }
  //       );
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  // const handleLivePolling = async (loc) => {
  //   try {
  //     const response = await axios.post(
  //       "https://api.more.in/v1/vigil_portal",
  //       {
  //         loc: [Number(loc)],
  //         rawPath: "/live_connection_polling",
  //         connection_id: connectionIdRef.current,
  //       },
  //       {
  //         headers: {
  //           Authorization: Cookies.get("ssp_sso_token"),
  //           "content-type": "application/json",
  //         },
  //       }
  //     );
  //     console.log(response);
  //   } catch (err) {
  //     console.log(err);
  //     toast.error("Something went wrong, please try again later!", {
  //       position: "top-right",
  //     });
  //   }
  // };

  // const handleGetPlayback = async () => {
  //   const loc = selectedLocs[0];
  //   try {
  //     const response = await axios.post(
  //       "https://api.more.in/v1/vigil_portal",
  //       { loc: loc, rawPath: "/playback" },
  //       {
  //         headers: {
  //           Authorization: Cookies.get("ssp_sso_token"),
  //           "content-type": "application/json",
  //         },
  //       }
  //     );
  //     if (response?.data?.status === "success") {
  //       setPlaybackdata(response?.data?.message?.records?.body);
  //       const dates = Object.keys(response?.data?.message?.records?.body).map(
  //         (date) => ({ playback_date: date })
  //       );
  //       setDatedetails(dates);
  //       handleLivePolling(loc);
  //       if (pollingRef.current) {
  //         clearInterval(pollingRef.current);
  //       }
  //       pollingRef.current = setInterval(() => {
  //         handleLivePolling(loc);
  //       }, 10000);
  //     } else {
  //       toast.error(
  //         response?.data?.body?.message || "Something went wrong, Please try again later!",
  //         { position: "top-right" }
  //       );
  //     }
  //   } catch (err) {
  //     console.log(err);
  //     toast.error("Something went wrong, Please try again later!", {
  //       position: "top-right",
  //     });
  //   }
  // };

  // // Cleanup polling on unmount
  // useEffect(() => {
  //   return () => {
  //     if (pollingRef.current) {
  //       clearInterval(pollingRef.current);
  //     }
  //   };
  // }, []);

  // useEffect(() => {
  //   handleGetDc();
  // }, []);

  // useEffect(() => {
  //   if (getdc.length > 0) {
  //     handleGetLogs();
  //   }
  // }, [selectedCity]);

  // useEffect(() => {
  //   if (selectedLocs.length > 0) {
  //     handleGetPlayback();
  //   }
  // }, [selectedLocs]);

  // useEffect(() => {
  //   setGridItems([]);
  // }, [selecteddate]);

  // const handleDrawerToggle = () => {
  //   setMobileOpen(!mobileOpen);
  // };
  // const handleToggleSidebar = () => {
  //   setIsSidebarOpen((prev) => !prev);
  // };
  // const handleCameraSelect = ({ cameraName, timeSlot, link }) => {
  //   setGridItems([link]);
  //   setSelectedcamera(cameraName);
  // };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        backgroundColor: COLORS.DARK_GRAY,
        color: "white",
        textAlign: "center",
        gap: 2,
      }}
    >
      <Typography variant="h1" sx={{ fontSize: "8rem", fontWeight: 700, lineHeight: 1, color: COLORS.PRIMARY ?? "#1976d2" }}>
        404
      </Typography>
      <Typography variant="h5" sx={{ fontWeight: 500, letterSpacing: 2, textTransform: "uppercase" }}>
        Page Not Found
      </Typography>
      <Typography variant="body1" sx={{ color: "gray", maxWidth: 400 }}>
        The page you're looking for doesn't exist
      </Typography>
    </Box>
  );
};

export default Rewatch;